function getBasePathFromUrl(url: string): string {
  return url.replace(/https?:\/\/[a-zA-Z0-9-.:]+/, '');
}

export default getBasePathFromUrl;
